import PatientsForm from './_PatientsForm';

export default PatientsForm;
